import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '720px', margin: '0 auto', lineHeight: '1.8' }}>
      <h1>プライバシーポリシー</h1>
      <p>
        O-Gnu Project（以下、「当プロジェクト」といいます）は、当プロジェクトが提供するアプリにおいて、利用者のプライバシーを尊重し、以下の通り個人情報を取り扱います。
      </p>

      <h2>1. 収集する情報</h2>
      <p>当プロジェクトが提供するアプリでは、以下の情報を収集する場合があります。</p>
      <ul>
        <li>広告配信のための広告ID（Google AdMob）</li>
        <li>将来的に導入予定の機能における、ニックネームおよびゲームスコア</li>
      </ul>

      <h2>2. 利用目的</h2>
      <ul>
        <li>アプリの広告配信および最適化</li>
        <li>ゲーム内ランキング表示機能（予定）</li>
      </ul>

      <h2>3. 情報の第三者提供</h2>
      <p>
        当プロジェクトでは、利用者の同意なしに個人情報を第三者に提供することはありません。ただし、Google AdMob 等の外部サービスにおいては、利用者情報が自動的に取得される場合があります。
      </p>

      <h2>4. 外部サービスの利用</h2>
      <p>以下の外部サービスを使用しています。</p>
      <ul>
        <li>Google AdMob（広告配信）</li>
      </ul>

      <h2>5. お問い合わせ</h2>
      <p>
        本プライバシーポリシーに関するお問い合わせは、以下のメールアドレスまでご連絡ください。<br />
        <strong>メールアドレス：</strong> <a href="mailto:kasutra1qaz@gmail.com">kasutra1qaz@gmail.com</a>
      </p>

      <h2>6. 改定について</h2>
      <p>
        本ポリシーは必要に応じて改定されることがあります。改定後の内容はこのページにて掲載されます。
      </p>

      <p style={{ marginTop: '2rem', fontSize: '0.9rem' }}>
        制定日：2025年5月23日
      </p>
    </div>
  );
};

export default PrivacyPolicy;
